import { batch, useDispatch } from 'react-redux'
import { useContext } from 'react'
import { FilterContext } from '../FilterContext'
import NoneAnchor from 'components/NoneAnchor'
import { addFilter } from '../dashboardFilterSlice'
import PropTypes from 'prop-types'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const NameFilterMenu = ({ menu, operator }) => {
  const dispatch = useDispatch()
  const { title, domain } = menu
  const { value, setValue, setMenuVisible } = useContext(FilterContext)
  return (
    <li>
      <NoneAnchor
        className="link_searchfilter"
        onClick={() => {
          setValue('')
          setMenuVisible(false)
          window.scrollTo({ top: 0 })
          batch(() => {
            dispatch(
              addFilter({
                domain,
                key: domain === 'keyword' ? 'text' : 'name',
                data: {
                  operator: operator.key,
                  value,
                },
              })
            )
            dispatch(campaignTableActions.setPage(0))
            dispatch(adGroupTableActions.setPage(0))
            dispatch(keywordTableActions.setPage(0))
            dispatch(creativeTableActions.setPage(0))
          })
        }}>
        {domain === 'keyword' ? title : `${title} 이름`}에{' '}
        <em className="fc_emph">{value}</em> {operator.name}
      </NoneAnchor>
    </li>
  )
}
NameFilterMenu.propTypes = {
  menu: PropTypes.shape({
    domain: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  operator: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
}
export default NameFilterMenu
